import { ALL_CATEGORY } from "@/components/nw-nav/store";
import { Course } from "@/api";

export type CategoryTopic = {
  type: "category";
  id: string;
  value: string;
};

export type CourseTopic = {
  type: "course";
  value: Course;
  id: string;
};

export type Topic = CategoryTopic | CourseTopic;

export function isCourse(topic: Topic): topic is CourseTopic {
  return topic.type === "course";
}

export function toTopic(value: string | Course): Topic {
  if (typeof value === "string") {
    return {
      id: value,
      type: "category",
      value,
    };
  }

  return {
    id: value.id!,
    type: "course",
    value,
  };
}

export function toCategory(topic: Topic): string {
  return topic.id;
}

export function formatCategory(value: string): string {
  return value === ALL_CATEGORY ? "All" : value;
}
